import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import { ReactComponent as Account } from 'assets/accountBig.svg'
import { ReactComponent as Checked } from 'assets/checked.svg'
import { ReactComponent as Safety } from 'assets/safety.svg'
import { useHistory, useParams } from 'react-router-dom'
import OutsourcePhotoPopup from './OutsourcePhotoPopup'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import BackBtn from 'components/buttons/BackBtn'
import usePopupState from 'hooks/usePopupState'
import { useReduxSelector } from 'store'
import { useState } from 'react'
import { useRef } from 'react'
import Item from './Item'

interface CameraProps {
  selectedData: payments.SelectedData
  selectData: React.Dispatch<React.SetStateAction<payments.SelectedData>>
}

const Camera: React.FC<CameraProps> = ({ selectedData, selectData }) => {
  const { id } = useParams<warehouse.PageParams>()
  const [photos, setPhotos] = useState<File[] | null>(selectedData?.photos || null)
  const { hasOnlineAccess } = useReduxSelector(state => selectWarehouse(state, id))
  const { popup, pathname } = usePopupState()

  const { push, goBack } = useHistory()
  const { t } = useTranslation('warehouse')

  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <>
      <div>
        {popup === 'photo' && <OutsourcePhotoPopup />}
      </div>

      <input
        ref={inputRef}
        type='file'
        accept='image/*'
        capture='environment'
        style={{ display: 'none' }}
        onChange={e => {
          const { files } = e.target
          if (files && files.length > 0) setPhotos(Array.from(files))
        }}
      />

      <div className='title'>
        <div>{t('takeAPicture')}</div>
        <div>{t('showThatTheWarehouseIsAlreadyEmptyClean')}<br />{t('andReadyForOtherCustomers')}</div>
      </div>

      <div className='resignation__main'>
        <div className='resignation__list'>
          <div className='list__label'>{t('whyPhotos')}</div>

          <Item
            icon={<Safety />}
            title={t('security')}
            desc={t('letsMakeSureYouDidntLeaveAnythingBehind')}
          />

          <Item
            icon={<Checked />}
            title={t('quality')}
            desc={t('weMakeSureThatTheMAGsAre100Efficient')}
          />

          <Item
            icon={<Account />}
            title={t('customersGood')}
            desc={t('everyoneWantsToRentACleanWarehouse')}
          />
        </div>
        {(photos || selectedData.documents) && <div className='resignation__list --filled'>
          <div className='list__label'>{t('attachedPhotos')}</div>
          <div className='resignation__gallery'>
            {selectedData.documents?.map(({ id, public_path, document_title }) => <div
              key={id}
              className='resignation__gallery__item'>
              <img
                src={public_path}
                alt={document_title}
              />
            </div>)}
            {photos?.map((file, idx) => <div
              key={id}
              className='resignation__gallery__item'>
              <div
                className='resignation__gallery__item__close'
                onClick={() => {
                  setPhotos(photos.length === 1 ? null : photos.filter((_, i) => i !== idx))
                }}>
                <i className='icon icon--close' />
              </div>
              <img
                src={URL.createObjectURL(file)}
                alt={file.name}
              />
            </div>)}
          </div>
        </div>}

        <div className='resignation__buttons'>
          <ArrowBtn
            enlarged
            text={photos
              ? photos.length === 1
                ? t('add1Photo')
                : `${t('add')} ${photos.length} ${t('photos')}}`
              : t(hasOnlineAccess ? 'openMagAndTakeAPicture' : 'takeAPicture')}
            action={() => {
              if (photos) {
                selectData(prev => ({ ...prev, photos }))
                goBack()
              } else {
                inputRef.current?.click()
              }
            }}
          />

          <BackBtn
            text={t('leaveItToUs')}
            action={() => {
              push(pathname, LOCATION_STATES.popup('photo'))
            }}
          />
        </div>
      </div>
    </>
  )
}

export default Camera